module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-81.f26e2f28.svg";